<div *ngIf="entity">
  <div *ngIf="imageSrc" class="image-holder p-l-10 p-r-10">
    <img [src]="imageSrc" alt="logo">
  </div>
  <div *ngIf="!imageSrc" class="image-holder p-l-10 p-r-10">
    <img [src]="'assets/images/organization.png'" alt="logo">
  </div>

  <div *ngIf="!contactsUpdatedInYear" class="m-b-10">
    <i class="fa fa-flag text-danger"></i>
    {{ 'DATA_PORTAL.ORGANIZATION_DETAIL.CONTACTS_NOT_UPDATED' | translate }}
  </div>
  <div *gsShowIfHasPermission="['CONTACTS_ORGANIZATION_UPDATE']">
    <div *ngIf="!contactsUpdatedInYear" class="flex-container m-b-10">
      <button (click)="onContactUpdate.emit()"
              class="contact-confirm-button m-r-10"
              label="{{ 'Confirm' | translate }}"
              pButton
              type="button">
      </button>
      <button [routerLink]="['/organizations', entity.id, 'modify', 'contacts']"
              class="contact-update-button"
              label="{{ 'Update' | translate }}"
              pButton
              type="button">
      </button>
    </div>
  </div>

  <div *ngIf="entity.supportCenter, else organization" class="m-b-15">
    <label *ngIf="entityLevel === searchEntityLevels.REGION">
      {{ 'DATA_PORTAL.REGION_DETAIL.SUPPORT_CENTRES' | translate }}
    </label>
    <label *ngIf="entityLevel === searchEntityLevels.WORLD">
      {{ 'DATA_PORTAL.WORLD_DETAIL.SUPPORT_CENTER' | translate }}
    </label>
    <a href="/organizations/{{entity.supportCenter?.id}}/detail"
       class="center-name-text">{{entity.supportCenter?.name}}</a>
    <p class="grey-hint-text">{{entity.supportCenter?.address.townCity}}
      , {{entity.supportCenter?.address.country.name}}</p>
  </div>

  <ng-template #organization>
    <div *ngIf="entity.organizationSubTypeData" class="m-b-10">
      {{entity.organizationSubTypeData.name}}
    </div>

    <div>
      <label class="organization-name m-b-10">
        {{entity.name}}
      </label>
    </div>
  </ng-template>

  <label *ngIf="entity.parentOrganizationId && showParent">
    {{ 'DATA_PORTAL.ORGANIZATION_DETAIL.PARENT' | translate }}
  </label>

  <div *ngIf="entity.parentOrganizationId && showParent" class="m-b-10">
    <a [routerLink]="['/data', entity.parentOrganizationId]">
      {{entity.parentOrganizationName}}
    </a>
  </div>

  <label *ngIf="entity.address?.country || entity.wsdCountryName">
    {{ 'DATA_PORTAL.ORGANIZATION_DETAIL.COUNTRY' | translate }}
  </label>

  <div *ngIf="entity.address?.country && entity.address?.country.name !== 'Not Applicable'" class="m-b-10">
    {{entity.address.country.name}}
  </div>

  <div *ngIf="entity.wsdCountryName && entity.address?.country.name === 'Not Applicable'" class="m-b-10">
    {{ entity.wsdCountryName }}
  </div>

  <label>
    {{ 'DATA_PORTAL.ORGANIZATION_DETAIL.REGION' | translate }}
  </label>

  <div *ngIf="entity.regionName" class="m-b-15">
    {{entity.regionName}}
  </div>

  <div *ngIf="entity.waggsMember" class="m-b-15">
    <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.WAGGGS_MEMBER_LABEL' | translate}}</label>
  </div>

  <div *ngIf="address" class="m-b-15">
    <label>
      {{ 'DATA_PORTAL.ORGANIZATION_DETAIL.ADDRESS' | translate }}
    </label>
    <p>{{ address?.address1 }}</p>
    <p>{{ address.address2 }}</p>
    <p>{{ address.address3 }}</p>
    <p>{{ address.address4 }}</p>
    <p>{{ address.townCity }} {{ address.zip }}</p>
    <p *ngIf="address.country?.name !== 'Not Applicable'">{{ address.country?.name }}</p>
  </div>

  <div *ngIf="entity.contacts?.length">
    <div class="m-b-15" *ngFor="let contact of entity.contacts">
      <div *ngIf="contact.visibleInDirectory">
        <label>
          {{ 'CONTACT_TYPES.' + contact.type | translate }}
        </label>
        <span>{{ contact.value }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="entity.appointees?.length > 0">
    <label>
      {{ 'DATA_PORTAL.ORGANIZATION_DETAIL.CONTACT_PERSON' | translate }}
    </label>

    <div class="m-b-15" *ngFor="let person of entity.appointees">
      <div>{{ person.firstName + ' ' + person.lastName }}</div>
      <a href="mailto:{{person.email}}">
        {{person.email}}
      </a>
    </div>
  </div>

</div>
